import { render, staticRenderFns } from "./LayoutC.vue?vue&type=template&id=5171ef60&scoped=true"
import script from "./LayoutC.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LayoutC.vue?vue&type=style&index=0&id=5171ef60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5171ef60",
  null
  
)

export default component.exports